import React, { useEffect } from "react";
import LoginLayout from "../../components/Common/LoginLayout/LoginLayout";
import { useLocation, useNavigate } from "react-router";
import { domains, isMatchingDomain } from "../../utils/ltimSSOLoginCondition";

const PreLoginPage = () => {
  debugger;
  const navigate = useNavigate();
  const location = useLocation();
  // Hybrid tenants land here via an in-app navigate carrying this state, so a
  // fresh/direct visit to "/" (no tenant) never bypasses the forced-AAD gate.
  const forceAAD =
    isMatchingDomain(domains) &&
    !localStorage.getItem("token") &&
    !location.state?.fromHybridTenant;

  useEffect(() => {
    // debugger;
    if (forceAAD) {
      navigate("/aadlogin");
    }
  }, []);

  return <>{!forceAAD && <LoginLayout prelogin={true} />}</>;
};

export default PreLoginPage;
